import {
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
  Stack,
  Button,
  Box,
} from '@mui/material';
import { toast } from 'react-toastify';
import Icon from '@/units/Icon';
import PublicAPI from '@/api/TreedisPublicDAO';
import socket from '@/components/util/socket';
import { useNotesContext } from '../../hooks/useNotesContext';
import { useNotesStore } from '../../stores/notes.store';

export const DeleteNoteModal = () => {
  const { tour, userId, currentAction, removeThreadFromSpace, setCurrentAction } =
    useNotesContext();

  const { deleteNote, selectNote } = useNotesStore((state) => state.actions);
  const selectedNote = useNotesStore((state) => state.selectedNote);

  const noteToDelete = currentAction?.note;
  const isOpen =
    !!currentAction &&
    currentAction.type === 'delete' &&
    !!currentAction.note &&
    !currentAction.message;

  const handleDelete = async () => {
    if (!noteToDelete || currentAction?.type !== 'delete') {
      toast.error('Could not delete note');
    }
    if (noteToDelete.userId !== userId) {
      toast.error('You can not delete this note');
      return;
    }

    const result = await PublicAPI.deleteThread({
      data: { threadId: noteToDelete.id },
    });

    if (result.message === 'Success') {
      deleteNote(noteToDelete.id);
      await removeThreadFromSpace(noteToDelete);
      socket.emit('thread_delete', { ...noteToDelete, room: tour?.slug });
    }

    if (selectedNote?.id === noteToDelete.id) {
      selectNote(null);
    }

    currentAction.onSuccess?.();
    setCurrentAction(null);
  };

  return (
    <Dialog
      open={isOpen}
      onClose={() => setCurrentAction(null)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      sx={{
        '& .MuiDialog-paper': { background: 'transparent', borderRadius: '12px' },
        '& .MuiBackdrop-root': {
          background: 'rgba(0, 0, 0, 0.40)',
          backdropFilter: 'blur(8px)',
        },
      }}
    >
      <Stack sx={{ maxWidth: '400px', background: 'white', borderRadius: '12px' }}>
        <DialogContent>
          <Box display="flex" alignItems="start" justifyContent="flex-start" paddingBottom={2}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '48px',
                height: '48px',
                borderRadius: '50%',
                background: '#FEF3F2',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '35px',
                  height: '35px',
                  borderRadius: '50%',
                  background: '#FEE4E2',
                }}
              >
                <Icon.Delete style={{ color: 'transparent', fontSize: 20 }} />
              </Box>
            </Box>
          </Box>
          <Typography variant="h6" align="left">
            Delete this note?
          </Typography>
          <Typography align="left" sx={{ color: '#667085', fontSize: '14px', fontWeight: '400' }}>
            Are you sure you want to delete this note? This action cannot be undone.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Stack
            direction="row"
            spacing={2}
            justifyContent="space-between"
            width="100%"
            padding={2}
          >
            <Button
              variant="outlined"
              onClick={() => setCurrentAction(null)}
              style={{
                color: '#344054',
                flex: 1,
                marginRight: 12,
                border: '1px solid #D0D5DD',
                borderRadius: 8,
                height: 48,
              }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={handleDelete}
              color="primary"
              style={{
                flex: 1,
                marginLeft: 12,
                borderRadius: 8,
                height: 48,
                background: '#D92D20',
              }}
            >
              Delete
            </Button>
          </Stack>
        </DialogActions>
      </Stack>
    </Dialog>
  );
};
